export default "__VITE_ASSET__DyDHHwG7__"